
import {Injectable, TemplateRef} from '@angular/core';
import {AuthService} from '../auth/auth.service';
import {Http} from '@angular/http';
import { ActivatedRoute } from '@angular/router';
import { UserQuota } from '../model/userquota.model';
import { Subscription } from 'rxjs';
import { EnrolToModuleService } from 'app/enrol-to-module/enrol-to-module.service';
import { BsModalRef } from 'ngx-bootstrap';

@Injectable()
export class BreezeService  {

    paramSub: Subscription;
 

    breezeSessionString: string;

    paramSubQuotaSession: Subscription;
    userQuota: UserQuota = new UserQuota();
    sessionFlag: boolean = false;
    quotaFlag: boolean = false;
    finalUserQuota: UserQuota = new UserQuota();
    modalRef: BsModalRef;
    

    foundPharmacistModule: boolean = false;




  constructor(private _authService: AuthService,
             private _route: ActivatedRoute,
             private enrolToModuleService: EnrolToModuleService,

              _http: Http) {
    
  }

  



  checkBothQuotaAndSession(module, spinner, modalSessionTemp, modalQuotaTemp, modalRef, modalService){

    spinner.show();

    this.getUserSessionAlive(module, spinner, modalSessionTemp, modalQuotaTemp, modalRef, modalService);





  }
  

  getUserSessionAlive(module, spinner, modalSessionTemp, modalQuotaTemp, modalRef, modalService) {
    this.paramSub = this._route.params.subscribe(params => {
      this.enrolToModuleService.isUserSessionAlive().subscribe(
        userQuota => {
          this.userQuota.sessionAlive = userQuota.sessionAlive;
          console.log("inside this.enrolToModuleService.getUserSessionAlive()");
          console.log(userQuota.quotaReached);

          this.sessionFlag = this.userQuota.sessionAlive;

          this.checkUserQuotaReached(module, spinner, modalSessionTemp, modalQuotaTemp, modalRef, modalService);
        },
        err => {
          console.log(err);
          spinner.hide();
        });
    });
  }


  checkUserQuotaReached(module, spinner, modalSessionTemp, modalQuotaTemp, modalRef, modalService) {
    this.paramSub = this._route.params.subscribe(params => {
      this.enrolToModuleService.checkQuotaReached().subscribe(
        userQuota => {
          this.userQuota.quotaReached = userQuota.quotaReached;
          console.log("inside this.enrolToModuleService.checkUserQuotaReached()");
          console.log(userQuota.quotaReached);
          
          this.quotaFlag = this.userQuota.quotaReached;

          this.openLink(module, spinner, modalSessionTemp, modalQuotaTemp, modalRef, modalService);

          
        },
        err => {
          console.log(err);
          spinner.hide();
        });
    });


  }


  openLink(module, spinner, modalSessionTemp, modalQuotaTemp, modalRef, modalService){

    console.log('Session Flag value = ' + this.sessionFlag);

    console.log('Quota Flag value = ' + this.quotaFlag);

    spinner.hide();

    if(this.sessionFlag == true && this.quotaFlag == false){

      spinner.hide(); 

      var userData = this._authService.getUserData() ;

      if (userData !== undefined && userData != null && this._authService.getUserData() !== null ) {
        this.breezeSessionString = this._authService.getUserData().breezeSessionString;
        this.breezeSessionString = this._authService.getBreezeSessionString();

        window.open(module.vurl+'?session='+this.breezeSessionString);
  
      }


      console.log(modalSessionTemp);

     
      //this.openModal(modalQuotaTemp, modalRef, modalService);

      
    }

    else if ( this.sessionFlag == false){

      spinner.hide();
      this.openModal(modalSessionTemp, modalRef, modalService);

    }

    else if ( this.quotaFlag == true){

      spinner.hide();
      this.openModal(modalQuotaTemp, modalRef, modalService);

    }

    spinner.hide();

 

 
  }


   openModal(template: TemplateRef<any>, modalRef, modalService){
    
    console.log();
    
    //this.modalSession.show();

    this.modalRef = modalService.show(template);
    

  }

  closeModal(){ 

    this.modalRef.hide();

  }
  



}



// WEBPACK FOOTER //
// ./src/app/shared/service/breeze.service.ts